import { ConfirmDialog } from '@gogame/components';
import { useMutation } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';

import { unblockPartnerUser } from '../../sources/partner-users';
import { block } from '../queryKeyFactory';

export const useUnblockPartnerUser = () => {
  const confirm = useScreenModalV2(ConfirmDialog);
  const unblockMutation = useMutation(block(), unblockPartnerUser, {
    successMessage: () => 'User unblocked',
  });

  const handleUnblock = async ({ id, name }) => {
    await confirm({
      title: `Unblock User?`,
      bodyText: name,
      confirmActionLabel: 'Unblock',
    });
    await unblockMutation.mutateAsync({ id });
  };
  return [handleUnblock, unblockMutation];
};
